import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getWarehouseInventorySummaryCount = unaryRpc({
  name: "getWarehouseInventorySummaryCount" as const,
  input: z.object({ location: z.string() }),
  output: z.object({ total: z.number() }),
});
